<ng-container *ngIf="settings$ | async as settings">
  <div *ngIf="showCaptcha">
    <div class="dialog-content">
      <div
        #humanometrWrapper
        id="humanometrWrapper"
        class="captcha-wrapper"
      ></div>
    </div>
  </div>
</ng-container>
